// Ant Design Table sortOrder prop requires 'ascend'/'descend', not 'asc'/'desc'
const ANT_DESIGN_SORT_ORDER = {
    asc: 'ascend',
    desc: 'descend'
};

export function getSortOrder(field, currentSorters) {
    if (currentSorters.sort !== field) return null;
    return ANT_DESIGN_SORT_ORDER[currentSorters.order] ?? null;
}
